<kendo-dropdownlist
  [data]="concepts"
  textField="name"
  valueField="id"
  (ngModelChange)="onConceptSelected($event)"
  [(ngModel)]="selectedConcept"
>
</kendo-dropdownlist>
